import Store from '../interfaces/Store';

export const INITIAL_VALUES: Store = {
  Loja: {
    Logradouro: '',
    Latitude: '',
    Longitude: '',
    Bairro: '',
    Cep: '',
    Cidade: '',
    UF: '',
    NumeroLoja: '',
    Nome: '',
    NumeroEstabelecimento: '',
    Telefone: '',

    id: '',
    flag_id: '',
    region_id: 0,
    format_id: 0,

    showInArcus: 1
  }
}
